import TalentPools from "../../views/TalentPools";

const TalentPoolsPage = () => {
  return <TalentPools />;
};

export default TalentPoolsPage;
